import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import MediaGatewayList from './containers/MediaGatewayList';
import MediaGatewayCreate from './containers/MediaGatewayCreate';
import MediaGatewayEdit from './containers/MediaGatewayEdit';
import MediaGatewayView from './containers/MediaGatewayView';
import NetworkCreateDialog from '../Network/containers/NetworkCreateDialog';
import { SYSTEM_CONFIGURATION_ROUTE, MEDIA_GATEWAY, SYSTEM } from '../../constants';

interface Props {
}

const MediaGateway: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${MEDIA_GATEWAY}`}>
        <MediaGatewayList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${MEDIA_GATEWAY}/create`}>
        <MediaGatewayCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${MEDIA_GATEWAY}/edit`}>
        <MediaGatewayEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${MEDIA_GATEWAY}/view`}>
        <MediaGatewayView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default MediaGateway;
